export enum TipoReportes{

    CATALOGO_GLOSAS,
    MAESTRO_SERVICIOS,
    PARAMETROS
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/descarga_reporte/modelo/TiposReporte.ts